const SECTIONS_BY_TYPE = {
    'RECENT': {
        title: 'Recent Searches',
        urlSection: null
    },
    'POPULAR': {
        title: 'Popular Searches',
        urlSection: null
    },
    'CREATOR': {
        title: 'Creators',
        urlSection: 'creators'
    },
    'STYLE': {
        title: 'Styles',
        urlSection: 'styles'
    },
    'SELLER': {
        title: 'Dealers',
        urlSection: 'dealers'
    }
};

const RECENT_SEARCHES = {
    TYPE: 'RECENT',
    LOCAL_STORAGE: 'recentSearches',
    MAX_TERMS: 6
};

const SEARCH_PAGE_PATH = '/search/';

const SEARCH_QUERY_PARAM = 'q';

const TRACKING = {
    CATEGORY: 'navigation',
    ACTION: 'header navigation click'
};

export {
    SECTIONS_BY_TYPE,
    RECENT_SEARCHES,
    SEARCH_PAGE_PATH,
    SEARCH_QUERY_PARAM,
    TRACKING
};



// WEBPACK FOOTER //
// ./src/components/SearchBar/searchBarConstants.js